import { customBeforeEnter } from '@/router'

const moduleRoute = {
  path: '/pacientes',
  component: () => import('@/views/Home.vue'),
  children: [
    {
      path: '',
      // Lista migrada para React (Strangler Fig) — a versão Vue
      // (./views/PatientsList.vue) sai do repo quando a migração do módulo
      // terminar. Perfil e formulário abaixo continuam Vue.
      component: () => import('@/views/Patients/PatientsListReact.vue')
    },

    {
      path: ':id',
      component: () => import('./views/PatientProfile.vue'),
      beforeEnter: (to, from, next) =>
        customBeforeEnter('FpPron1', to, from, next),
      children: [
        {
          path: 'edit',
          component: () => import('@/views/Patients/PatientForm.vue')
        },
        {
          path: 'account',
          component: () =>
            import('@/components/AppointmentModal/AccountContent.vue')
        }
      ]
    }
  ]
}

export default router => {
  router.addRoute(moduleRoute)
}
